export enum ChangelogActionType {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED',
  UPLOADED = 'UPLOADED',
  INQUIRED = 'INQUIRED',
  SUBMITTED = 'SUBMITTED',
  ASSIGNED = 'ASSIGNED',
}
